import { StripeAction, StripeActionType } from '../actions/stripe';
import { StripeNamespace } from '../state/stripe';

export const stripeReducer = (
    state: StripeNamespace = {
        paymentType: null,
    },
    action: StripeAction,
): StripeNamespace => {
    switch (action.type) {
        case StripeActionType.setPaymentType:
            return {
                ...state,
                paymentType: action.payload,
            };
        default:
            return state;
    }
};
